import { getMemoryCache } from './memory.store';
import { LogiSDKConfig } from '../model/config';

export const getSDKConfig = (): LogiSDKConfig => {
  const swipeSDKConfig = getMemoryCache('config');
  return swipeSDKConfig;
};
